import React from 'react'
import '../estilos/QuieneSomos.css'
import { useTranslation } from 'react-i18next';

function AboutIntro() {
  const { t } = useTranslation();
  return (
    <section className="about-intro">
      <div className="about-intro-container">
        <div className="about-intro-text">
          <h2 className="about-intro-title">{t('quienes_historia')}</h2>
          <div className="about-intro-line"></div>
          <p className="about-intro-paragraph">
            {t('historia_de_pacific')}
          </p>
          <p className="about-intro-paragraph">
            {t('motivos')}
          </p>
          <p className="about-intro-highlight">
            {t('nuestra_filosofia')}
          </p>
        </div>
        <div className="about-intro-image-wrapper">
          <img
            src="https://dynamic-media.tacdn.com/media/photo-o/2f/03/0b/20/caption.jpg?w=700&h=500&s="
            alt="Tour nautico en el Pacifico de Costa Rica"
            className="about-intro-image"
          />
          <div className="about-intro-badge">
            <span className="about-intro-badge-year">{t("extra_de_about")}</span>
            <span className="about-intro-badge-number">2012</span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutIntro
